import { useState } from 'react';
import '../../styles/pages/Admin/Dashboard.scss';
import SERVER from '../../hooks/useServer';
import axios from 'axios';
import {formatPrice} from '../../hooks/generalHooks';
import { toast } from 'react-toastify';

const AdminCommandes = ({ activeTab, commandes, setCommandes }) => {
    // State declarations
    const [loading, setLoading] = useState(null)
    const [error, setError] = useState(null);
    const [itemsPerPage] = useState(5);
    const [currentPageCommandes, setCurrentPageCommandes] = useState(1);
    // Calculate pagination
    const [selectedCommande, setSelectedCommande] = useState(null);
    const [commandeSearchTerm, setCommandeSearchTerm] = useState('');
    const [commandeStatusFilter, setCommandeStatusFilter] = useState('');
    const filteredCommandes = commandes.filter(commande => 
        commandeStatusFilter ? commande.status === commandeStatusFilter : true
    )
    .filter(commande => 
        commandeSearchTerm 
        ? commande.client_name.toLowerCase().includes(commandeSearchTerm.toLowerCase()) ||
            commande.client_email.toLowerCase().includes(commandeSearchTerm.toLowerCase()) ||
            commande.id.toString().includes(commandeSearchTerm)
        : true
    );

    if (loading) return <div className="loading">Chargement...</div>;
    if (error) return <div className="error">Erreur: {error}</div>;
    return (
        <div className='admin'>
            {activeTab === 'commandes' && (
                <div className="admin-section">
                    <h2>Commandes</h2>
                    
                    {/* Search and filter controls */}
                    <div className="commandes-controls">
                        <input
                            type="text"
                            placeholder="Rechercher commandes..."
                            className="search-input"
                            onChange={(e) => setCommandeSearchTerm(e.target.value)}
                        />
                        <select
                            value={commandeStatusFilter}
                            onChange={(e) => setCommandeStatusFilter(e.target.value)}
                            className="status-filter"
                        >
                            <option value="">Tous les statuts</option>
                            <option value="En attente">En attente</option>
                            <option value="En préparation">En préparation</option>
                            <option value="Expédiée">Expédiée</option>
                            <option value="Livrée">Livrée</option>
                            <option value="Annulée">Annulée</option>
                        </select>
                    </div>

                    <div className="admin-table-container">
                        <table className="admin-table commandes-table">
                            <thead>
                                <tr>
                                    <th>Client</th>
                                    <th>Articles</th>
                                    <th>Total</th>
                                    <th>Statut</th>
                                    <th className="actions-column">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCommandes.map(commande => (
                                    <tr key={commande.id} className={`commande-row ${commande.status.toLowerCase().replace(' ', '-')}`}>
                                        <td className="client-info">
                                            <div className='client-address'> {commande.order_number} </div>
                                            <div className="client-name">{commande.client_name}</div>
                                            <div className="client-contact">
                                                <span className="email">{commande.client_email}</span>
                                                <span className="phone">{commande.client_phone}</span>
                                            </div>
                                            {commande.client_address && (
                                                <div className="client-address">{commande.client_address}</div>
                                            )}
                                            {commande.notes && (
                                                <div className="client-notes">
                                                    <strong>Notes:</strong> {commande.notes}
                                                </div>
                                            )}
                                        </td>
                                        <td className="commande-items">
                                            <div className="items-container">
                                                {commande.items?.map((item, index) => (
                                                    <div key={item.id || index} className="commande-item">
                                                        <div className="item-details">
                                                            <div className="item-title">{item.title}</div>
                                                            <div className="item-price-qty">
                                                                {formatPrice(item.price)} × {item.quantity}
                                                            </div>
                                                            <div className="item-total">
                                                                Total: {formatPrice(item.price * item.quantity)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </td>
                                        <td className="commande-total">
                                            € {formatPrice(commande.total)}
                                        </td>
                                        <td className="commande-status">
                                            <select
                                                value={commande.status}
                                                onChange={async (e) => {
                                                    try {
                                                        const updated = await axios.put(
                                                            `${SERVER}/commandes/${commande.id}/status`,
                                                            { status: e.target.value }
                                                        );
                                                        setCommandes(commandes.map(c => 
                                                            c.id === commande.id ? { ...updated.data, items: c.items } : c
                                                        ));
                                                        toast.success('Statut mis à jour avec succès');
                                                    } catch (error) {
                                                        toast.error('Erreur lors de la mise à jour du statut');
                                                        console.error('Error updating status:', error);
                                                    }
                                                }}
                                            >
                                                <option value="En attente">En attente</option>
                                                <option value="En préparation">En préparation</option>
                                                <option value="Expédiée">Expédiée</option>
                                                <option value="Livrée">Livrée</option>
                                                <option value="Annulée">Annulée</option>
                                            </select>
                                        </td>
                                        <td className="commande-actions">
                                            <div className="actions-container">
                                                <button 
                                                    className="details-button"
                                                    onClick={() => setSelectedCommande(commande)}
                                                >
                                                    Détails
                                                </button>
                                                <button 
                                                    className="delete-button"
                                                    onClick={async () => {
                                                        if (window.confirm('Supprimer cette commande?')) {
                                                            try {
                                                                await axios.delete(`${SERVER}/commandes/${commande.id}`);
                                                                setCommandes(commandes.filter(c => c.id !== commande.id));
                                                                toast.success('Commande supprimée avec succès');
                                                            } catch (error) {
                                                                toast.error('Erreur lors de la suppression');
                                                                console.error('Error deleting commande:', error);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    Supprimer
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        
                        {/* Pagination */}
                        <div className="pagination">
                            {Array.from({ length: Math.ceil(filteredCommandes.length / itemsPerPage) }).map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentPageCommandes(index + 1)}
                                    className={currentPageCommandes === index + 1 ? 'active' : ''}
                                >
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Commande Detail Modal */}
                    {selectedCommande && (
                        <div className="commande-modal">
                            <div className="modal-content">
                                <span className="close-button" onClick={() => setSelectedCommande(null)}>
                                    &times;
                                </span>
                                <h3>Détails de la commande  <i>{selectedCommande.order_number}</i></h3>
                                
                                <div className="commande-details">
                                    <div className="detail-section">
                                        <h4>Client</h4>
                                        <p><strong>Nom:</strong> {selectedCommande.client_name}</p>
                                        <p><strong>Email:</strong> {selectedCommande.client_email}</p>
                                        <p><strong>Téléphone:</strong> {selectedCommande.client_phone}</p>
                                        <p><strong>Adresse:</strong> <br />{selectedCommande.client_address.split("\n").map((line, index) => (
                                            <span key={index}>{line}<br /></span>
                                            ))}
                                        </p>
                                        {selectedCommande.notes && (
                                            <p><strong>Notes:</strong> {selectedCommande.notes}</p>
                                        )}
                                    </div>
                                    
                                    <div className="detail-section">
                                        <h4>Articles</h4>
                                        <div className="items-list">
                                            {selectedCommande.items?.map((item, index) => (
                                                <div key={item.id || index} className="item-detail">
                                                    <img src={`${SERVER}/${item.banner_image}`} alt={item.title} />
                                                    <div>
                                                        <p><strong>{item.title}</strong></p>
                                                        <p>Prix unitaire: € {formatPrice(item.price)}</p>
                                                        <p>Quantité: {item.quantity}</p>
                                                        <p>Calibrage: € {item.calibrage > 0 ? formatPrice(parseFloat(item.calibrage * item.quantity)) : 'Non' } </p>
                                                        <p>Sous-total: € {formatPrice((item.price * item.quantity) + (item.calibrage * item.quantity))}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    
                                    <div className="detail-section">
                                        <h4>Total: {formatPrice(selectedCommande.total)}</h4>
                                        <p><strong>Statut:</strong> {selectedCommande.status}</p>
                                        <p><strong>Date:</strong> {new Date(selectedCommande.created_at).toLocaleString('fr-FR')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
    
};

export default AdminCommandes;